<template>
  <div class="shop">
    <div class="top" style="margin-bottom:10px">
      <el-button size="small" type="primary" @click="exportWoods"
        >导出数据</el-button
      >

      <el-button
        style="float:right"
        class="search"
        size="small"
        type="primary"
        @click="searchList"
        >搜索</el-button
      >
      <el-input
        style="float:right"
        class="search input"
        size="small"
        v-model="cardNum"
        placeholder="红包卡批次号"
        clearable
      ></el-input>
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="box_id"></el-table-column>
      <el-table-column label="盒ID" prop="box_sn"></el-table-column>
      <el-table-column label="面值" prop="card_amount"></el-table-column>
      <el-table-column label="是否激活" prop="active_name"></el-table-column>
      <el-table-column label="授权时间" prop="bind_time"></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="unBindItem(scope.row)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--编辑弹窗-->
    <jdialog title="解绑" :visible.sync="unbindingShow" width="440px">
      <el-form
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-select
          style="width:100%;"
          size="small"
          v-model="user_id"
          filterable
          class="search"
          @change="onChangeSalerList"
          placeholder="选择转移销售"
        >
          <el-option
            v-for="item in salerList"
            :label="item.name"
            :value="item.user_id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="unbindingShow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="creatUnbindingMove"
          >确定</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { getLookBcList, setUnbundling,unbundlingMove } from '@/api/redpacketManage'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      box_id: '', //解绑ID
      unbindingShow: false, //解绑弹窗
      user_id: '', //转移推广员ID
      salerList: [], //转移推广员列表
      cardNum: '', // 搜索批次号
      tableData: [],
      labelPosition: 'right',
      is_export: 0, //0非导出，1导出
      form: {
        page: 1
      },
      total: 0
    }
  },
  mounted() {
    this.getLookBcList()
  },
  methods: {
    //获取列表数据
    async getLookBcList() {
      let is_export = this.is_export
      let cardNum = this.cardNum
      let saler_id = this.$route.query.saler_id
      let url = `page=${this.form.page}&is_export=${is_export}&box_sn=${cardNum}&saler_id=${saler_id}`
      let res = await getLookBcList(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
          this.salerList = res.data.salee_info
        }
      } else {
        this.$message.error(res.message)
      }
    },
    //导出
    exportWoods() {
      this.is_export = 1
      this.getLookBcList()
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getLookBcList()
    },
    //确认解绑
    async setUnbundling(postData) {
      let res = await setUnbundling(postData)
      if (res.code === 10000) {
        this.getLookBcList()
        this.$message.success(res.message)
        this.box_id = ''
        this.unbindingShow = false
      } else {
        this.box_id = ''
        this.unbindingShow = false
        this.$message.error(res.message)
      }
    },
   //确认解绑+转移
    async unbundlingMove(postData) {
      let res = await unbundlingMove(postData)
      if (res.code === 10000) {
        this.getLookBcList()
        this.$message.success(res.message)
        this.box_id = ''
        this.user_id = ''
        this.unbindingShow = false
      } else {
        this.box_id = ''
        this.user_id = ''
        this.unbindingShow = false
        this.$message.error(res.message)
      }
    }, 
    // 解绑
    unBindItem(info) {
      console.log(info)
      this.box_id = info.box_id
      if (info.card_status == 1) {
        this.creatUnbinding()
      } else {
        this.unbindingShow = true
      }
    },
    //确认解绑
    creatUnbinding() {
      let box_id = this.box_id
      let saler_id = this.$route.query.saler_id
      let postData = {
        box_id: box_id,
        saler_id: saler_id
      }
      this.setUnbundling(postData)
    },
    //确认解绑+转移弹窗确认按钮
    creatUnbindingMove() {
      let box_id = this.box_id
      let saler_id = this.$route.query.saler_id
      let postData = {
        box_id: box_id,
        saler_id: saler_id,
        user_id: this.user_id
      }
      this.unbundlingMove(postData)
    },
    //选择转移推广员
    onChangeSalerList() {
      console.log(this.user_id)
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getLookBcList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top .input {
    width: 150px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
